// ** saylov
const initialState = {
  mahalla_mtp: false
  // tuman_mtp: false,
  // gom_mtp: false
}

const mtp = (state = initialState, action) => {
  switch (action.type) {
    case "MAHALLA_MTP":
      return { ...state, mahalla_mtp: action.val }
    // case "TUMAN_MTP":
    //   return { ...state, tuman_mtp: action.val }
    // case "GOM_MTP":
    //   return { ...state, gom_mtp: action.val }
    default:
      return state
  }
}

export default mtp
